import React, {useState, useEffect} from 'react';
import FieldLabel from './field-label';
import FieldPlaceholder from './field-placeholder';
import FieldHelpText from './field-help-text';
import InitialValue from './initial-value/initial-value';
import FieldMandatory from './field-mandatory';
import NbCharsRestriction from './nb-chars-restriction';
import CharTypeRestrictions from './char-type-restrictions';
import FieldWidth from './field-width';
import ConditionId from './condition-id';
import FieldNoteForDevelopers from './note-for-developers';

const TextField = ({id, conditions, value, onChange}) => {

  const [model, setModel] = useState(value);

  useEffect(() => { onChange(model); }, [model]);

  return <>
    <FieldLabel value={model.label}
                onChange={v => setModel({...model, label: v})}/>
    <FieldPlaceholder value={model.placeholder}
                      onChange={v => setModel({...model, placeholder: v})}/>
    <FieldHelpText value={model.helpText}
                   onChange={v => setModel({...model, helpText: v})}/>
    <InitialValue fieldType={model.fieldType}
                  value={model.initialValue || {}}
                  radioBoxPrefix={id}
                  onChange={newValue => setModel({
                    ...model,
                    initialValue: newValue
                  })}/>
    <FieldMandatory id={id}
                    value={model.mandatory}
                    onChange={v => setModel({...model, mandatory: v})}
                    conditionallyDisplayed={!!model.conditionId}/>
    <NbCharsRestriction radioBoxPrefix={id}
                        value={model.nbCharsRestriction || {}}
                        onChange={value => setModel({...model, nbCharsRestriction: value})}/>
    <CharTypeRestrictions value={model.charTypeRestrictions || {}}
                          onChange={value => setModel({...model, charTypeRestrictions: value})}/>
    <FieldWidth value={model.widthInPercent}
                onChange={v => setModel({...model, widthInPercent: v})}/>
    <ConditionId id={id}
                 conditions={conditions}
                 value={model.conditionId}
                 onChange={v => setModel({...model, conditionId: v})}/>
    <FieldNoteForDevelopers label={model.label}
                            placeholder={model.placeholder}/>
  </>;
};

export default TextField;
